const DIRECT_API_URL =
  'https://pt8lbf5drh.execute-api.us-east-1.amazonaws.com/dev/walllabs_create'

const PROXY_API_URL = '/api/walllabs_create'

const X_API_KEY = (
  process.env.VUE_APP_WALLLABS_API_KEY ||
  'p4DCTzH6tm2ctNyS0VE344fenvBDJfCq7GDaj6lC'
).trim()

export const S3_WALLPAPER_BASE =
  'https://walllabs-bucket.s3.amazonaws.com/wallpaper/'

function getHeaders() {
  return {
    'Content-Type': 'application/json',
    'X-Api-Key': X_API_KEY
  }
}

function getApiUrlCandidates() {
  const configured = String(process.env.VUE_APP_WALLLABS_API_URL || '').trim()
  const candidates = []

  // Same-origin proxy works on localhost (devServer) and live hosts (Vercel/Netlify/Apache).
  if (typeof window !== 'undefined') {
    candidates.push(PROXY_API_URL)
  }

  if (configured && !candidates.includes(configured)) {
    candidates.push(configured)
  }

  if (!candidates.includes(DIRECT_API_URL)) {
    candidates.push(DIRECT_API_URL)
  }

  return candidates
}

function isRetryableNetworkError(error) {
  const message = String(error?.message || '').toLowerCase()
  return (
    error?.name === 'TypeError' ||
    message.includes('failed to fetch') ||
    message.includes('networkerror') ||
    message.includes('load failed') ||
    message.includes('cors')
  )
}

async function requestOnce(apiUrl, body) {
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body)
  })

  let data = {}
  try {
    data = await response.json()
  } catch {
    data = {}
  }

  if (!response.ok) {
    throw new Error(
      data?.Message || data?.message || `API Error: ${response.status}`
    )
  }

  if (data?.Status && String(data.Status).toUpperCase() !== 'SUCCESS') {
    throw new Error(data?.Message || data?.message || 'Request failed')
  }

  return data
}

export async function wallLabsRequest(body) {
  const candidates = getApiUrlCandidates()
  let lastError = null

  for (let index = 0; index < candidates.length; index += 1) {
    const apiUrl = candidates[index]
    try {
      return await requestOnce(apiUrl, body)
    } catch (error) {
      lastError = error
      const canRetry =
        index < candidates.length - 1 && isRetryableNetworkError(error)
      if (!canRetry) {
        throw error
      }
    }
  }

  throw lastError || new Error('API request failed')
}

export function listWallpapers() {
  return wallLabsRequest({ command: 'listWallpapers' })
}

export function addWallpaper({ wallpaper_name, category, s3_url }) {
  return wallLabsRequest({
    command: 'addWallpaper',
    wallpaper_name: String(wallpaper_name || '').trim(),
    category: String(category || '').trim(),
    s3_url: String(s3_url || '').trim()
  })
}

export function buildDefaultS3Url(wallpaperName, fileName = '') {
  const title = String(wallpaperName || '').trim() || 'wallpaper'
  const extension =
    String(fileName).match(/\.(png|jpe?g|webp|gif|jfif)$/i)?.[1]?.toLowerCase() ||
    'png'
  const safeTitle = encodeURIComponent(title.replace(/[\\/:*?"<>|#%{}^~[\]`]/g, ''))
  return `${S3_WALLPAPER_BASE}${safeTitle}.${extension}`
}
